// export const BASE_URL = 'https://gapi.runbit.io/api/v1/'
// export const IMAGE_PREFIX_URL = "https://gapi.runbit.io/"
export const ENV = "prod";  // prod  test

export const IMAGE_PREFIX_URL =
  ENV === "prod" ? "https://gapi.runbit.io" : "http://16.163.40.119:8899";
export const CHAIN_IMAGE_PREFIX_URL =  ENV === "prod"
  ? "https://gapi.runbit.io"
  : "http://16.163.40.119:8090";

export const BASE_URL =  ENV === "prod"
  ? "https://gapi.runbit.io/api/v1/"
  : "http://16.163.40.119:8899/api/v1/";


export const tabbarPath = ["/", "/shop", "/bag"];
export const headerPath = ["/", "/shop", "/bag"];
// export const IMAGE_PREFIX_URL = "http://16.163.40.119:8866"
// export const CHAIN_IMAGE_PREFIX_URL = "http://16.163.40.119:8090"

// export const BASE_URL = 'http://16.163.40.119:8866/api/v1/'
export const LEVELS_SELECT_OPTIONS = [
  [
    {
      value: "",
      i18n: "common.all",
      label: "全部",
    },
    // {
    //   value: 1,
    //   i18n: "common.level_1",
    //   label: "一级",
    // },
    // {
    //   value: 2,
    //   i18n: "common.level_2",
    //   label: "二级",
    // },
    {
      value: 3,
      i18n: "common.level_3",
      label: "三级",
    },
    {
      value: 4,
      i18n: 'common.level_4',
      label: "四级",
    },
    {
      value: 5,
      i18n: 'common.level_5',
      label: "五级",
    },
  ],
];

export const EQUIPS_TYPE_OPTIONS = [
  {
    value: "",
    i18n: "common.all",
    label: "全部",
  },
  {
    value: 0,
    i18n: "common.type_2",
    label: "鞋子",
  },
  {
    value: 1,
    i18n: "common.type_1",
    label: "裤子",
  },
  {
    value: 2,
    i18n: "common.type_3",
    label: "衣服",
  },
];
